import { EmojiProperties, WithName } from './DataTypes'

export function emojiNames(emoji: WithName): string[] {
  return emoji[EmojiProperties.name] ?? []
}
